import React, { createContext, useMemo, useState } from "react";
import { Menu } from "../templates/sidebar/data/MenuItems";
import { GetLocStorage, GetPrivileges, GetRoleId, GetUserId } from "../utils";
import { ROLES } from "@/data/Constant";


export const PrivilegeContext = createContext();

const PrivilegesContextWrapper = (props) => {

    const [authorizedPages, setAuthorizedPages] = useState([])
    const [patheName, setPatheName] = useState('')
    const [isLoggedIn, setIsLoggedIn] = useState(GetLocStorage("ut") ? true : false);
    const [userName, setUserName] = useState(null);
    const [roleName, setRoleName] = useState(null);


    const privileges = useMemo(() => {
        let directLink = window.location.href.split("#")[1]?.split("?")[0]
        let ControllerId = Menu?.find(screen => [patheName, directLink].includes(screen.path))?.id[0];
        if (!ControllerId) {
            Menu?.forEach(screens => screens["children"]?.forEach(ele => {
                ControllerId = [patheName, directLink].includes(ele.path) ? ele.id : ControllerId
            }))
        }

        return GetPrivileges(authorizedPages, ControllerId)

    }, [authorizedPages, window.location, patheName])

    const userRoleId = useMemo(() => GetRoleId(), [isLoggedIn])
    const userId = useMemo(() => GetUserId(), [isLoggedIn])
    
    const state = {
        privileges,
        authorizedPages,
        userRoleId,
        setUserName,
        userName,
        setIsLoggedIn,
        isSuperAdmin : userRoleId == ROLES.SUPER_ADMIN,
        isLoggedIn,
        userId,
        setAuthorizedPages,
        setPatheName,
        roleName,
        setRoleName
    }

    return <PrivilegeContext.Provider value={state}>{props.children}</PrivilegeContext.Provider>;
};

export default PrivilegesContextWrapper;